export default function (value) {
  let dict = [
    {
      id: 1,
      role: 'admin',
      rolename: 'Администратор'
    },
    {
      id: 2,
      role: 'user',
      rolename: 'Студент'
    },
    {
      id: 3,
      role: 'methodist',
      rolename: 'Методист'
    },
    {
      id: 4,
      role: 'leader',
      rolename: 'Руководитель'
    },
    {
      id: 5,
      role: 'leader_admin',
      rolename: 'Системный администратор'
    }
  ]
  let rolename = ''
  if (value) {
    dict.forEach((item) => {
      if (value == item.id || value == item.role) {
        rolename = item.rolename
      }
    })
  }
  return rolename
}
